/**
 * DevExtreme (esm/__internal/grids/new/grid_core/inferno_wrappers/utils.js)
 * Version: 25.1.4
 * Build date: Tue Aug 05 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
export function wrapRef(ref) {
    return {
        dxRenderer: true,
        get 0() {
            return ref.current
        },
        get: () => ref.current,
        length: 1
    }
}
